<template>
  <div class="social-bars" v-if="isLoaded">
    <div class="fb-bar" v-if="social.facebook === '' ? false : true">
      <a :href="social.facebook" target="_blank"
        ><i class="fa fa-facebook pointer-hover"></i
      ></a>
    </div>
    <div class="twitter-bar" v-if="social.facebook === '' ? false : true">
      <a :href="social.twitter" target="_blank"
        ><i class="fa fa-twitter pointer-hover"></i
      ></a>
    </div>
    <div class="insta-bar" v-if="social.instagram === '' ? false : true">
      <a :href="social.instagram" target="_blank"
        ><i class="fa fa-instagram pointer-hover"></i
      ></a>
    </div>
    <div class="linked-bar" v-if="social.linkedin === '' ? false : true">
      <a :href="social.linkedin" target="_blank"
        ><i class="fa fa-linkedin pointer-hover"></i
      ></a>
    </div>
    <div class="youtube-bar" v-if="social.youtube === '' ? false : true">
      <a :href="social.youtube" target="_blank"
        ><i class="fa fa-youtube pointer-hover"></i
      ></a>
    </div>
    <div class="flickr-bar" v-if="social.flickr === '' ? false : true">
      <a :href="social.flickr" target="_blank"
        ><i class="fa fa-flickr pointer-hover"></i
      ></a>
    </div>
    <div
      class="podacast-bar final-bar"
      v-if="social.podcast === '' ? false : true"
    >
      <a :href="social.podcast" target="_blank"
        ><i class="fa fa-podcast pointer-hover"></i
      ></a>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("footer");

export default {
  name: "Social",
  data() {
    return {
      isLoaded: false,
      social: {},
    };
  },
  async mounted() {
    this.isLoaded = false;
    UserRepository.footerInfo().then((res) => {
      const { data } = res;
      this.social = data;
      this.isLoaded = true;
    });
  },
};
</script>

<style lang="scss">
.social-bars {
  left: 0;
  top: 28vh;
  position: fixed;
  z-index: 1000;
  margin-bottom: 100px;
}

.social-bars div {
  height: 50px;
  width: 50px;
  transition: 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    display: block;
    color: #fff;
    font-size: 1.5rem;
  }
}

.social-bars div a {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fb-bar {
  background-color: rgb(61, 90, 152);
  padding: 7px;
}

.fb-bar a {
  height: 40px;
  width: 40px;
}

.insta-bar {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  padding: 7px;
}

.insta-bar a {
  display: block;
  height: 40px;
  width: 40px;
}

.linked-bar {
  background-color: rgb(25, 118, 210);
  padding: 7px;
}

.linked-bar a {
  height: 40px;
  width: 40px;
}
.youtube-bar {
  background-color: #ff0000;
}

.twitter-bar {
  background-color: rgb(3, 169, 244);
  padding: 11px;
}

.flickr-bar {
  background-color: #0063dc;
}

.podacast-bar {
  background-color: #c764f0;
}

.social-bars div:first-child {
  border-top-right-radius: 10px;
}

.social-bars div:last-child {
  border-bottom-right-radius: 10px;
}

.twitter-bar a {
  height: 30px;
  width: 30px;
}

.social-bars div:hover {
  margin-left: 5px;
  width: 60px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
